import { render, staticRenderFns } from "./Component-NewTask-Home.vue?vue&type=template&id=103d72f6&scoped=true&"
import script from "./Component-NewTask-Home.vue?vue&type=script&lang=js&"
export * from "./Component-NewTask-Home.vue?vue&type=script&lang=js&"
import style0 from "./Component-NewTask-Home.vue?vue&type=style&index=0&id=103d72f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "103d72f6",
  null
  
)

export default component.exports